import { Component, computed, input } from '@angular/core';

import { CmsTeaser } from '@fcom/core-api';

import { toLinkData } from '../../services/template/data-mappers';

@Component({
  selector: 'cms-cta-big-link',
  template: `
    <fin-cta-big-link
      [target]="cmsTarget()"
      [teaserTitle]="content().teaserTitle"
      [teaserText]="content().teaserText"
      class="mr-medium-t mr-xlarge-b block"
    />
  `,
  styleUrls: ['./cms-cta-big-link.component.scss'],
  standalone: false,
})
export class CmsCtaBigLinkComponent {
  content = input.required<CmsTeaser>();

  cmsTarget = computed(() => {
    return toLinkData(this.content().target);
  });
}
